/**
 * Australian phone number validator + cleaner.
 *
 * Mobile: 04XX XXX XXX (10 digits, starts 04)
 * Landline: 0[2378]X XXXX XXXX (10 digits, area codes 02/03/07/08)
 * International: +61 prefix, then 4XX/2/3/7/8 + 8 digits
 *
 * Spaces, hyphens and parentheses are stripped before checking.
 */
const AU_PHONE_RE = /^(?:0[234578]\d{8}|614\d{8}|612\d{8}|613\d{8}|617\d{8}|618\d{8})$/;

export function cleanPhone(raw) {
  return String(raw || "").replace(/[\s\-()]/g, "").replace(/^\+/, "");
}

export function isValidAuPhone(raw) {
  if (!raw) return false;
  return AU_PHONE_RE.test(cleanPhone(raw));
}

/**
 * Format raw phone digits into the display style the cashier expects:
 *   0400123456 → 0400 123 456
 *   +61400123456 → +61 400 123 456
 *   0712345678 → (07) 1234 5678
 * Returns the raw input unchanged if it doesn't look like a recognisable
 * AU number, so half-typed values stay editable.
 */
export function formatAuPhone(raw) {
  const cleaned = cleanPhone(raw);
  if (!cleaned) return raw;
  if (cleaned.startsWith("614") && cleaned.length === 11) {
    return `+61 ${cleaned.slice(3, 6)} ${cleaned.slice(6, 9)} ${cleaned.slice(9)}`;
  }
  if (/^(612|613|617|618)/.test(cleaned) && cleaned.length === 11) {
    return `+61 ${cleaned[2]} ${cleaned.slice(3, 7)} ${cleaned.slice(7)}`;
  }
  if (/^04/.test(cleaned) && cleaned.length === 10) {
    return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`;
  }
  if (/^0[2378]/.test(cleaned) && cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)} ${cleaned.slice(6)}`;
  }
  return raw;
}
